import { ErrorPage } from '../index';
import { initServerTranslation } from '@bts-web/utils-lokalise';

const ErrorServerPage = async () => {
  const { t } = await initServerTranslation();

  return (
    <ErrorPage
      title={t('internal_error_headline', {
        defaultValue: `We're having internal connection problems`,
      })}
      description={t('internal_error_text', {
        defaultValue: 'Try relaunching the app.',
      })}
    />
  );
};

export { ErrorServerPage };
